
import React, { useEffect } from 'react'
import { Container, Header, Icon, Menu, Label, Divider, Grid } from 'semantic-ui-react'
import AboutRealstate from '../../../components/AboutRealstate/AboutRealstate';
import { useTranslation } from "react-i18next";
import AccommodationRooms from '../../../components/AccommodationRooms/AccommodationRooms';
import AccommodationBathrooms from '../../../components/AccommodationBathrooms/AccommodationBathrooms';
import AccommodationFacilities from '../../../components/AccommodationFacilities/AccommodationFacilities';

import "./Section2.css"
import AccommodationAvailableDates from '../../../components/AccommodationAvailableDates/AccommodationAvailableDates';
import RealstateDetails from '../../../components/RealstateDetails/RealstateDetails';
import RealstateFurtherInformation from '../../../components/RealstateFurtherInformation/RealstateFurtherInformation';

const Section2 = ({ fixed }) => {
    const { t } = useTranslation();


    useEffect(() => {
        console.log(fixed)
    }, [fixed])

    return (<Container className="bg-white RealStateSection2" >
        <Menu className={`m-5-t  bg-white ${fixed ? "d-block" : "d-none"}`} secondary fixed={fixed ? 'top' : null} >
            <Container>
                <Menu.Item
                    as="a"
                    href="#property-section1"
                    name={t("property:Photos")}
                />
                <Menu.Item
                    as="a"
                    href="#amenities"
                    name={t("property:Amenities")}
                />
                <Menu.Item
                    as="a"
                    href="#property-section3"
                    name={t("property:Reviews")}
                />
                <Menu.Item
                    as="a"
                    href="#location-section"
                    name={t("property:Location")}
                />
            </Container>
        </Menu>

        <Grid columns={3} stackable>
            <Grid.Column className="p-2-t" width={8}>
                <Header as='h2'>
                    <span className="text-g m-05-r m-05-l">اتوبان تهران كرج شهرك جهان كرج شهرك جهان نما</span>
                </Header>
                <Grid.Row>
                    <Label size="large" basic className="border-none">
                        <Icon name="map" />
                        {/* {t("property:AreaCode/Name")} : */}
                        <a className="text-blue m-05-r m-05-l">شهرك جهان نما</a>
                    </Label>
                </Grid.Row>

                <Grid.Row>
                    <Label size="large" basic className="border-none">
                        <Icon name="user" />
                        {/* {t("property:Landlord")} : */}
                        <span className="m-05-r m-05-l"> املاك تعاون</span>
                    </Label>
                    </Grid.Row>
                    <Grid.Row>
                         <Label size="large" basic className="border-none">
                        <Icon name="phone" />
                        {/* {t("property:Telephone")} : */}
                        <span className="border-none">02632313157 </span>
                        {/* ,<span  className="border-none">02632313157 </span>
                        ,<span  className="border-none">02632313157 </span> */}


                    </Label>
                </Grid.Row>

            </Grid.Column>
            <Grid.Column width={1}></Grid.Column>
            <Grid.Column className="p-2-t" width={7}>
                <Header as='h2'>
                    <span className="text-g m-05-r m-05-l">1,326,000,000 {t("property:Toman")}</span>
                </Header>

                <Grid.Row>
                    <Label size="large" basic className="border-none">
                        <Icon name="building" />
                        {/* {t("property:LandArea")} : */}
                        <span className="m-05-r m-05-l">200 متر مربع</span>
                    </Label>
                </Grid.Row>
                <Grid.Row>

                    <Label size="large" basic className="border-none">
                        <Icon name="tag" />
                        {/* {t("property:PricePerMeter")} : */}
                        <span className="m-05-r m-05-l">17,000,000  {t("property:Toman")}</span>
                    </Label>
                </Grid.Row>
                <Grid.Row>

                    <Label size="large" basic className="border-none">
                        <Icon name="info" />
                        {/* {t("property:PriceDescription")} : */}
                        <span className="m-05-r m-05-l">توضیحات در این قسمت نوشته می شود</span>
                    </Label>
                </Grid.Row>
                

            </Grid.Column>
        </Grid>
        <AboutRealstate />
        <RealstateDetails/>        
        <RealstateFurtherInformation/>
       
    </Container>

    )
}
export default Section2